import { render, staticRenderFns } from "./IlluCoursLive.vue?vue&type=template&id=2c7ce586&"
import script from "./IlluCoursLive.vue?vue&type=script&lang=js&"
export * from "./IlluCoursLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports